module.exports = __webpack_public_path__ + "static/media/surveyComplete.b661b6f0.png";